const focusOptionsPolyfill = require("focus-options-polyfill") // polyfill for safari
import CONSTANTS from "./Constants";

export default class Dialog{

    constructor(element, closeButton ){
        this.element = element;
        this.closeButton = closeButton;

        this.trapFocus()
    }

    trapFocus() {
        let focusableEls;
        if(Array.isArray(this.element)){
            focusableEls = [];
            this.element.forEach((item) => {
                focusableEls = focusableEls.concat(Array.prototype.slice.call(item.querySelectorAll(`a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), *[tabindex]:not([tabindex="-1"])`)));
            })
        }else{
            focusableEls = this.element.querySelectorAll(`a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), *[tabindex]:not([tabindex="-1"])`);
        }
        let firstFocusableEl = focusableEls[0];
        let lastFocusableEl = focusableEls[focusableEls.length - 1];

        if (lastFocusableEl.nodeName === 'IFRAME' || (lastFocusableEl.className.indexOf('maglr-video') && lastFocusableEl.children.length > 0 && lastFocusableEl.children[0].nodeName === 'IFRAME')) {
            const focusTrapLast = document.createElement( 'div' ); // create new textarea
            focusTrapLast.className = 'focus-trap-last'
            focusTrapLast.setAttribute('tabindex', 0)
            focusTrapLast.onfocus = (e) => {
                this.keydown({key: CONSTANTS.KEYS.TAB})
            }
            lastFocusableEl.parentNode.insertBefore( focusTrapLast, lastFocusableEl.nextSibling );

            lastFocusableEl = focusTrapLast
        }

        this.keydown = (e) => {
            const isTabPressed = (e.key === CONSTANTS.KEYS.TAB || e.keyCode === CONSTANTS.KEYS.CODES.TAB);

            if (!isTabPressed) {
                if(e.key === CONSTANTS.KEYS.ESC || e.keyCode === CONSTANTS.KEYS.CODES.ESC){
                    this.releaseFocus(true);
                }
                return;
            }

            if ( e.shiftKey ) /* shift + tab */ {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault && e.preventDefault();
                }
            } else /* tab */ {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault && e.preventDefault();
                }
            }

        }
        document.addEventListener('keydown', this.keydown);
        firstFocusableEl && firstFocusableEl.focus({preventScroll:true});

        return this.keydown;
    }

    releaseFocus(triggerClose = false) {
        if (triggerClose) {
            const evt = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            });
            let canceled = !this.closeButton.dispatchEvent(evt);
        }
        document.removeEventListener('keydown', this.keydown);
    }
}
